export const getMargins = (margins) => margins && margins.join(' ');
//# sourceMappingURL=get-margins.js.map